module.exports = __webpack_public_path__ + "assets/img/s2_tab1_active_m.3b186d2f.png";